'use client';

import React, { Component } from 'react';

import Team from '../reusable-components/layouts-components__mts-invest/team';
import Ciphers from '../reusable-components/layouts-components__mts-invest/ciphers';
import Results from '../reusable-components/layouts-components__mts-invest/results';
import Pages from '../reusable-components/layouts-components__mts-invest/pages';
import TechAudit from '../reusable-components/layouts-components__mts-invest/tech-audit';
import Process from '../reusable-components/layouts-components__mts-invest/process';
import Complex from '../reusable-components/layouts-components__mts-invest/complex';
import Task from '../reusable-components/layouts-components__mts-invest/task';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import Review from '../reusable-components/layouts-components__common-cases/review';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';

import './style.sass';
import OfferButton from '../../../../../shared/sections/OfferButton';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import CommonSmallText from '../common-components/common-small-text';
import CommonSmallTitle from '../common-components/common-small-title';

const mtsInvestMainTitle = {
    titleMainText: `Как увеличить трафик сайта в&nbsp;4&nbsp;раза, благодаря SEO и&nbsp;текстам`,
    titleAnimation: '/images/pic/preview/mts.png',
    subtitleContainer: [
        {
            modeText: 'Клиент',
            colorMode: '#e51908',
            nameText: 'МТС Инвестиции',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#e51908',
            nameText: 'Финтех',
        },
        {
            modeText: 'Услуги',
            colorMode: '#e51908',
            nameText: 'SEO, продвижение сайта',
        },
        {
            modeText: 'Инструменты',
            colorMode: '#e51908',
            nameText: 'Технические тесты',
            subnameText:
                'Screaming Frog, Google PageSpeed Tools, GTmetrix, Dareboost, cURL, Bertal',
        },
        {
            colorMode: '#e51908',
            nameText: 'Текстовые анализаторы и&nbsp;кластеризаторы, сервисы сбора позиций',
            subnameText:
                'SEMparser, Топвизор, Яндекс.XML, Key Collector, Ahrefs, SimilarWeb, Text.ru',
        },
    ],
};

const reviewMtsInvest = {
    reviewText:
        'Команда Вебпрактик помогла нам определить вектор развития SEO-направления, формализовать задачи и системно двигаться по ним для достижения результата. Коллеги быстро понимают и принимают в работу задачи, относятся к клиенту как к партнеру. Однозначно, продолжим сотрудничество в следующем году.',
    reviewAuthors: [
        {
            title: 'Михаил Чернышов',
            subtitle: 'Руководитель проекта',
        },
    ],
    downLoadPresentationText: '&nbsp; Получить презентацию кейса',
};

class MtsInvest extends Component {
    render() {
        const casePathname = '/cases/marketing/mts-invest';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section className="mts-invest">
                <MainTitle MainTitle={mtsInvestMainTitle}>
                    <CommonSmallTitle>
                        <span style={{ color: '#e51908' }}>МТС Инвестиции</span>
                    </CommonSmallTitle>
                    <CommonSmallText isOneParagraph={false}>
                        Это сервис, позволяющий инвестировать в&nbsp;паевые инвестиционные фонды.
                        Услуги доверительного управления предоставляет УК&nbsp;&laquo;Система
                        Капитал&raquo;, входящая в&nbsp;группу &laquo;АФК Система&raquo;
                        и&nbsp;&laquo;МТС&raquo;.
                    </CommonSmallText>
                    <CommonSmallText>
                        Цель &laquo;МТС Инвестиций&raquo;&nbsp;&mdash; создание культуры сбережения
                        капитала, бережное отношение к&nbsp;деньгам инвесторов и&nbsp;приумножение.
                        УК&nbsp;&laquo;Система Капитал&raquo; доверяют многие частные
                        и&nbsp;институциональные клиенты.
                    </CommonSmallText>
                </MainTitle>

                <Task />

                <Complex />

                <Process />

                <TechAudit />

                <Pages />

                <Results />

                <Ciphers />

                <Team />

                <Review Review={reviewMtsInvest} />
                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default MtsInvest;
